import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import GroupService from "../services/group.service";
import DropdownWithImages from "../component/DropdownWithImages";
import { useDispatch } from "react-redux";
import {useTranslation} from 'react-i18next';
import Button from '@mui/material/Button';
import ColorPickerModal from '../component/ColorPickerModal';

const BoardUser = () => {

  const currentMainThemeColor = localStorage.getItem("currentMainThemeColor") ?? "#135c13";
  const currentSecondaryThemeColor = localStorage.getItem("currentSecondaryThemeColor") ?? "#cfcfcf";

  const styles = {
    pageTitle: {
      padding: '2rem 1rem',
      marginBottom: '2rem',
      backgroundColor: currentSecondaryThemeColor, 
      borderRadius: '0.3rem',
      height: 200,
      display: 'flex',
      justifyContent: 'center',
    },
    settingGroup: {
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'center', 
      alignItems: 'center',
      marginBottom: 25,
    },
    colorSettting:{
      display: 'flex',
      flexDirection: 'row',
      marginTop: 12,
      maxWidth: 300,
      minWidth: 255,
      justifyContent: 'space-between',
    }
  }

  const { groups: currentGroups } = useSelector((state) => state.group);
  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const {t, i18n} = useTranslation();

  const [isMainThemeModalVisible, setIsMainThemeModalVisible] =
      React.useState(false);
  
  const [isSecondaryThemeModalVisible, setIsSecondaryThemeModalVisible] =
      React.useState(false);

  useEffect(() => {
    if(!currentGroups)
      GroupService.getGroups(currentUser.token, dispatch);
  }, []);

  const activeGroup = localStorage.getItem("activeGroup");

  const onChangeActiveGroup = (value) => {
    localStorage.setItem("activeGroup", value);
    
    if (currentGroups && value) {
      const activeGroupId = currentGroups.find(group => group.name === value)?._id;
      if (activeGroupId) {
        localStorage.setItem("activeGroupId", activeGroupId);
      }
    }
  };

  const setMainThemeColor = (value) => {
    localStorage.setItem("currentMainThemeColor", value);
  };

  const setSecondaryThemeColor = (value) => {
    localStorage.setItem("currentSecondaryThemeColor", value);
  };

  return (
    <div className="container">
      <header style={styles.pageTitle}>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <h1>{'Settings'}</h1>
        </div>
      </header>
      <div style={styles.settingGroup}>
        <p style={{fontFamily: 'Comic Sans MS', fontSize: 22}}>
          Active Group
        </p>
        <div style={{ width: 300 }}>
          <DropdownWithImages preSelected={activeGroup} items={currentGroups} onChange={onChangeActiveGroup} />
        </div>
      </div>
      <div style={styles.settingGroup}>
        <p style={{fontFamily: 'Comic Sans MS', fontSize: 22}}>
          {t("ThemeSettings")}
        </p>
        <div
          style={styles.colorSettting}>
          <p style={{fontSize: 20}}>{t("MainTheme")}:</p>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              marginStart: 4,
            }}>
            <Button
              title="     "
              style={{ background: currentMainThemeColor }}
              color={currentMainThemeColor}
              onClick={() => { setIsMainThemeModalVisible(true); }}
            />
          </div>
        </div>
        <div
          style={styles.colorSettting}>
          <p style={{fontSize: 20}}>{t("SecondaryTheme")}:</p>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              marginStart: 4,
            }}>
            <Button
              title="     "
              style={{ background: currentSecondaryThemeColor }}
              color={currentSecondaryThemeColor}
              onClick={() => { setIsSecondaryThemeModalVisible(true); }}
            />
          </div>
        </div>
      </div>
      <ColorPickerModal
        currentColor={currentMainThemeColor}
        buttonColor={currentMainThemeColor}
        modalVisible={isMainThemeModalVisible}
        setModalVisible={setIsMainThemeModalVisible}
        setColor={setMainThemeColor}
      />
      <ColorPickerModal
        currentColor={currentSecondaryThemeColor}
        buttonColor={currentMainThemeColor}
        modalVisible={isSecondaryThemeModalVisible}
        setModalVisible={setIsSecondaryThemeModalVisible}
        setColor={setSecondaryThemeColor}
      />
    </div>
  );
};

export default BoardUser;
